import { ProjectImport } from './Imports'
const { RoutesMap, ProjectList, ProjectDetails, AddProject, UpdateProject } = ProjectImport

const ProjectRoute = () => {
    return [
        {
            path: RoutesMap.PROJECT_LIST.path,
            element: <ProjectList />
        },
        {
            path: RoutesMap.PROJECT_DETAILS.path,
            element: <ProjectDetails />
        },
        {
            path: RoutesMap.ADD_PROJECT.path,
            element: <AddProject />
        },
        {
            path: RoutesMap.UPDATE_PROJECT.path,
            element: <UpdateProject />
        },
    ]
}

export default ProjectRoute;